import React from "react";
import { AllRewardsPoints } from "../../common/icons";

const NewPricePointsComponent = ({
  currency,
  price,
  existsPWP,
  pointsPWP,
  isQbr,
  a11yText,
  priceContainerClass,
  isDiscounted,
  discountAmt,
  couponExists,
  couponTotal,
}) => (
  <div
    className={`flex flex-col gap-2 justify-center items-center ${priceContainerClass}`}
  >
    <div className="text-center">
      {isDiscounted && discountAmt ? (
        <p className="text-red-500 line-through leading-5 font-semibold mb-2 text-lg">
          <span>{currency}</span> {isDiscounted && <del>{discountAmt}</del>}
        </p>
      ) : null}
      <p className="text-2xl leading-5 text-[#18A09F] font-semibold">
        {couponExists ? `${couponTotal} ${currency}` : `${currency} ${price}`}
      </p>
      {couponExists && <p className="text-[#18A09F]">coupon applied</p>}
      {!couponExists && <PricePerYear className="text-[#18A09F]" />}
    </div>
    {existsPWP && pointsPWP && !isQbr && (
      <PointsDisplayComponent points={pointsPWP} a11yText={a11yText} />
    )}
  </div>
);

const PointsDisplayComponent = ({ a11yText, points }) => {
  return (
    <div className="flex flex-col gap-2 justify-center items-center font-semibold">
      <p className="text-xs">{a11yText || "OR"}</p>
      <p className="leading-5 text-2xl text-[#3D4892]">
        {Number(points).toLocaleString("en-US").replace(/,/i, " ")}{" "}
        <AllRewardsPoints />
      </p>

      <PricePerYear className="text-[#3D4892]" />
    </div>
  );
};

const PricePerYear = ({ className }) => {
  return (
    <p className={`text-sm leading-5 font-semibold ${className}`}>per year</p>
  );
};

export default function ProductPricePoints(props) {
  const {
    currency,
    totalAmt,
    isUserLogged,
    isQbr,
    languages,
    PWP,
    getCoupon,
    item,
    locationData,
    getPWPComponent,
  } = props;

  let pwpObject = {};
  const discountAmt = (
    Number(item.purchase_base_price) + Number(item.base_tax_amt)
  ).toLocaleString("en-US");
  const isDiscounted =
    Number(item.purchase_base_price) > Number(item.purchase_price);

  if (PWP !== false) {
    pwpObject = PWP;
  }
  const {
    multiProductPwpLoggedInMessage,
    multiProductPwpLoggedOutMessage,
    multiProductOr,
  } = languages || {};
  const {
    points: pwpPoints,
    isPWPExclusive,
    exists: pwpExists,
  } = pwpObject || {};
  const { total: couponTotal, exists: couponExists } = getCoupon;
  const { qbrPoints } = item || {};
  return (
    <>
      <div className="holder-text flex flex-col gap-2 justify-center items-center bg-[#F9FAFB] p-4 rounded-[4px] font-montserrat h-[156px]">
        {/* User is Logged in - Start */}
        {isUserLogged && (
          <React.Fragment>
            {isPWPExclusive ? (
              <span>
                {getPWPComponent(
                  multiProductPwpLoggedInMessage,
                  "Per Year ALL - Accor Live Limitless Reward points",
                  pwpPoints
                )}
              </span>
            ) : (
              <React.Fragment>
                <NewPricePointsComponent
                  currency={currency}
                  price={totalAmt}
                  pointsPWP={pwpPoints}
                  existsPWP={pwpExists}
                  isQbr={isQbr}
                  a11yText={multiProductOr}
                  isDiscounted={isDiscounted}
                  discountAmt={discountAmt}
                />
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        {/* User is Logged in - End */}

        {/* User is NOT LOGGED-IN - Start */}
        {!isUserLogged && (
          <React.Fragment>
            {isPWPExclusive ? (
              <span>
                {getPWPComponent(
                  multiProductPwpLoggedOutMessage,
                  "Per Year ALL - Accor Live Limitless Reward points",
                  pwpPoints
                )}
              </span>
            ) : (
              <React.Fragment>
                <NewPricePointsComponent
                  currency={currency}
                  price={totalAmt}
                  pointsPWP={pwpPoints}
                  existsPWP={pwpExists}
                  isQbr={isQbr}
                  a11yText={multiProductOr}
                  isDiscounted={isDiscounted}
                  discountAmt={discountAmt}
                  couponExists={couponExists}
                  couponTotal={couponTotal}
                />
                {/* */}
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        {/* User is NOT LOGGED-IN - End */}
      </div>

      {/* {isQbr && (
        <>
          <div className="py-3">
            <p className="font-montserrat font-bold">
              Earn {qbrPoints} Qantas Points with Qantas Business Rewards*
            </p>
          </div>
          {languages.qbrRewardPoints && (
            <div className="py-3">
              <p className="font-montserrat font-bold">
                {languages.qbrRewardPoints} {languages.qbrRewardPointsMessage}
              </p>
            </div>
          )}
          {languages.qbrBreakfastVoucher && (
            <div className="py-3">
              <p className="font-montserrat font-bold">
                {languages.qbrBreakfastVoucher}
              </p>
            </div>
          )}
        </>
      )} */}
    </>
  );
}

//OLD CODE

/* 

***First Line
<div className='py-3'>
                            <span className={clsx('font-montserrat font-medium',
                                {
                                    'total-amount': !discount,
                                    'discount-amount': discount
                                })}>
                                <span>{currency} </span>
                                {totalAmt.toLocaleString("en-US") + ' '}
                            </span>
                            <span className='uppercase'>
                                {discount && (
                                    <del>{discountAmt}</del>
                                )}
                                {multiProductYear || 'Per Year'}
                            </span>
                        </div>
                        {exists && points && !isQbr && (
                            <PointsDisplayComponent a11yText={multiProductOr} />
                        )} 
                            
                        
        ----------------------------------------------------------------------                
                        
*** Second Line                           
            <div className='py-3'>
                            <span className={`font-montserrat font-medium ${discount && !couponExists ? 'discount-amount' : 'total-amount'}`}>
                                <span>{currency} </span>{couponExists ? couponTotal + ' ' + currency + ' (coupon applied)' : totalAmt.toLocaleString("en-US") + ' '}
                            </span>
                            <span className='uppercase'>
                                {discount && !getCoupon.exists && (
                                    <del>{discountAmt}</del>
                                )}
                                {couponExists ? '' : + ' ' + (multiProductYear || 'Per Year')}</span>
                        </div>
                        {pwpExists && pwpPoints && !isQbr && (
                            <PointsDisplayComponent a11yText={multiProductOr} points={pwpPoints} />
                        )}             
               
                        
        */
